import Vue from 'vue'
const debug = {
  notifyError({
    error,
    message,
    metaData
  }) {
    return _logReport({
      error,
      metaData,
      message
    });
  }
};

// 日志上报
function _logReport({
  error,
  metaData,
  message
}) {
  message = message || error && error.message || '';
  const name = error && error.name || 'error',
    stacktrace = error && error.stack || '',
    time = new Date(),
    url = window.location.href,
    client = {
      userAgent: window.navigator.userAgent,
      height: window.screen.height,
      width: window.screen.width,
      referrer: window.document.referrer
    };
  const obj = {
    message,
    metaData,
    name,
    stacktrace,
    time,
    url,
    client
  };
  console.log(obj);
  // this.$dialog.alert(JSON.stringify(obj))
  return JSON.stringify(obj)
}

function formatComponentName(vm) {
  if (vm.$root === vm) return 'root';
  const name = vm._isVue ?
    (vm.$options && vm.$options.name) ||
    (vm.$options && vm.$options._componentTag) :
    vm.name;
  return (
    (name ? 'component <' + name + '>' : 'anonymous component') +
    (vm._isVue && vm.$options && vm.$options.__file ?
      ' at ' + (vm.$options && vm.$options.__file) :
      '')
  );
}

function listenPageError() {
  Vue.config.errorHandler = function (error, vm, info) {
    let metaData = {};
    if (vm) {
      const componentName = formatComponentName(vm),
        propsData = vm.$options && vm.$options.propsData;
      metaData = {
        componentName,
        propsData,
        info,
        userToken: {
          userId: 1
        } //metaData可以存一些额外数据，比如：用户信息等
      };
    } else {
      metaData = {
        userToken: {
          userId: 1
        } //metaData可以存一些额外数据，比如：用户信息等
      }
    }
    const errorInfo = debug.notifyError({
      error,
      metaData
    });
    return errorInfo;
  };

  window.onerror = function (message, error) {
    const errorInfo = debug.notifyError({
      error,
      message,
      metaData: {
        userToken: {
          userId: 1
        } //metaData可以存一些额外数据，比如：用户信息等
      }
    });
    return errorInfo;
  }
}
//最后我们把debug抛到外面供其他地方调用
export {
  listenPageError,
  _logReport
}